import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Dropdown, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Axios from "axios";

//STYLES
import * as navBarStyles from "./styles/navBar";

//NAV METHODS
import pageNavigation from "./navBarClickMethods";

function BrowserNavBar(props) {
    const [menu, setMenu] = useState({
        selected: "Select",
        items: []
    });
    const [width, setWidth] = useState(12);

    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        loadPodsAndPages();
    }, []);

    function loadPodsAndPages() {
        Axios.post("/pods/devHub/getPodsAndPages")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    let item = "Select";
                    if (location.pathname != "/") {
                        if (location.pathname.indexOf("/membership/") == 0) {
                            setWidth(12);
                            props.setMembership(true);
                        } else {
                            const details = location.pathname.split("/");
                            if (details[1] == "pod") {
                                const subValues = details[2].split("+");
                                item = data.items.find((item) => item.frontEndCode == subValues[0]);
                                setWidth(parseInt(subValues[1]));
                            }
                            if (details[1] == "page") {
                                const subValues = details[2].split("+");
                                item = data.items.find((item) => item.type == `page` && item.uuid == subValues[0]);
                                setWidth(parseInt(subValues[1]));
                            }

                            props.setMembership(false);
                        }
                    } else {
                        props.setMembership(false);
                    }
                    setMenu((prevState) => {
                        return { ...prevState, items: data.items, selected: item };
                    });
                }
            })
            .catch((err) => {});
    }

    function handleHome() {
        navigate("/");

        setMenu((prevState) => {
            return { ...prevState, selected: "Select" };
        });
    }

    function handleItemSelect(item) {
        setMenu((prevState) => {
            return { ...prevState, selected: item };
        });
        if (item.type == "pod") {
            navigate(`./pod/${item.frontEndCode}+${width}`);
        }
        if (item.type == "page") {
            navigate(`./page/${item.uuid}+${width}`);
        }
    }

    function increaseWith() {
        if (width < 12) {
            const newSize = width + 1;
            setWidth(newSize);

            if (menu.selected != "Select") {
                if (menu.selected.type == "pod") {
                    navigate(`./pod/${menu.selected.frontEndCode}+${newSize}`);
                }
                if (menu.selected.type == "page") {
                    navigate(`./page/${menu.selected.uuid}+${newSize}`);
                }
            }
        }
    }

    function decreaseWidth() {
        if (width > 1) {
            const newSize = width - 1;
            setWidth(newSize);

            if (menu.selected != "Select") {
                if (menu.selected.type == "pod") {
                    navigate(`./pod/${menu.selected.frontEndCode}+${newSize}`);
                }
                if (menu.selected.type == "page") {
                    navigate(`./page/${menu.selected.uuid}+${newSize}`);
                }
            }
        }
    }

    return (
        <div>
            <div style={navBarStyles.navOverAll}>
                <Row style={navBarStyles.navStyle}>
                    <Col>
                        <Row>
                            <Col style={navBarStyles.navTitle} onClick={handleHome}>
                                DEV HUB
                            </Col>
                        </Row>
                    </Col>
                    <Col style={navBarStyles.navPod}>Pod:</Col>
                    <Col style={navBarStyles.navDropdown}>
                        <Dropdown>
                            <Dropdown.Toggle>{menu.selected == "Select" ? "Select" : menu.selected.title}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {menu.items.map((item, index) => {
                                    return (
                                        <Dropdown.Item key={index} onClick={handleItemSelect.bind(this, item)}>
                                            {item.title}
                                        </Dropdown.Item>
                                    );
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    <Col style={navBarStyles.membershipTitle}>
                        <div style={props.membership ? navBarStyles.visible : navBarStyles.hidden}>Membership</div>
                    </Col>
                    <Col style={navBarStyles.columnWidthTitle}>Column Width: {width}</Col>
                    <Col style={navBarStyles.columnWidth}>
                        <Button onClick={decreaseWidth}>-</Button>
                        <Button onClick={increaseWith}>+</Button>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default BrowserNavBar;
